export default "<div id=\"NameTag\">John W. Surina</div>\n"